import * as CodeMirror from 'codemirror';
import { throttle, get } from "lodash-es";
import { delay } from "../../../../lib/utils";
import { cssToCamelCase } from "../../../../lib/comps/PropPanel/StylePanel/utils/func";
export function installCodeMirrorCssInlineWidget(cm, getCheckBoxNode) {
  const widgets = [];
  const updateWidgets = throttle(async () => {
    // 有时候刷新之后viewport会返回from: 0,to:0 所以要延迟
    await delay(0);
    cm.operation(() => {
      const viewport = cm.getViewport();
      if (viewport.from === 0 && viewport.to === 0) {
        // 刚刷新完还没刷出来行 不做处理
        return;
      }
      widgets.forEach(w => w.clear());
      widgets.length = 0;
      // [from,to)
      const node = getCheckBoxNode();
      for (let line = viewport.from; line < viewport.to; line += 1) {
        const tokens = cm.getLineTokens(line);
        tokens.filter(token => token.type === 'property').forEach(token => {
          const styleProps = cssToCamelCase(token.string);
          const element = get(node, ['$refs', `checkbox-${styleProps}`]);
          if (!element) return;
          const res = cm.setBookmark(CodeMirror.Pos(line, token.start), {
            widget: element
          });
          widgets.push(res);
        });
      }
    });
  }, 500);
  cm.on('viewportChange', updateWidgets);
  cm.on('change', updateWidgets);
  cm.on('blur', () => updateWidgets.flush());
  updateWidgets();
  return updateWidgets;
}
//# sourceMappingURL=uicore-css-inline-widget.js.map
